const changeCustomerAddress = async (
  input,
  userId,
  defaultAddress = null,
  addressId = null
) => {
  try {
    const response = await fetch('/api/shopify/customer/account/address', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        input,
        userId,
        defaultAddress,
        addressId
      })
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw {
        success: false,
        message: 'Failed to update customer address',
        data: errorData
      };
    }

    const data = await response.json();

    return { success: true, data };
  } catch (error) {
    console.error('Error updating customer address:', error);
    return {
      success: false,
      message:
        error?.message ||
        'An unexpected error occurred updating customer address'
    };
  }
};

export { changeCustomerAddress };
